import { render } from "./VerifyBankID.vue?vue&type=template&id=4ec056e0&scoped=true&ts=true"
import script from "./VerifyBankID.vue?vue&type=script&lang=ts"
export * from "./VerifyBankID.vue?vue&type=script&lang=ts"

import "./VerifyBankID.vue?vue&type=style&index=0&id=4ec056e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec056e0"]])

export default __exports__